import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedWMPCitiesList } from './WMPCitiesList';
import { WMPUtils } from '../../utils';
import { SearchProp } from '../../models';

export function WMPSource(search, field, segmentIndex) {
    const citiesIatas = WMPUtils.getCitiesList(search, field, segmentIndex);

    return {
        render: (options) => <ConnectedWMPCitiesList key={field+segmentIndex} {...options} field={field} citiesIatas={citiesIatas} />
    };
}

WMPSource.propTypes = {
    search: SearchProp.isRequired,
    field: PropTypes.oneOf(['from', 'to']).isRequired,
    segmentIndex: PropTypes.number
};
